import { Button, ButtonGroup, Paper, Typography } from "@material-ui/core";
import clsx from "clsx";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import StatisticsComponentItem from "./StatisticsComponentItem/StatisticsComponentItem";
import { StatisticsComponentProps } from "./StatisticsComponentProps";
import { statisticsComponentStyles } from "./StatisticsComponentStyles";

export default observer(function StatisticsComponent(
    props: StatisticsComponentProps
) {
    const { commonStore } = useStore();

    const classes = statisticsComponentStyles();
    return (
        <Paper
            elevation={0}
            className={clsx(classes.component, {
                [classes.componentWithoutButton]: !props.button,
            })}
        >
            {props.button && (
                <div className={classes.buttonContainer}>
                    <ButtonGroup>
                        <Button
                            className={clsx(classes.buttonCelsius, {
                                [classes.selectedButton]:
                                    commonStore.isCelsiusShowed,
                            })}
                            onClick={commonStore.setCelsiusShowed}
                        >
                            °C
                        </Button>
                        <Button
                            className={clsx(classes.buttonFahrenheit, {
                                [classes.selectedButton]:
                                    commonStore.isFahrenheitShowed,
                            })}
                            onClick={commonStore.setFahrenheitShowed}
                        >
                            °F
                        </Button>
                    </ButtonGroup>
                </div>
            )}
            <div style={{ display: "flex", alignItems: "start" }}>
                <Typography variant="h5" className={classes.title}>
                    {props.title}
                    {props.subTitle?.length && (
                        <Typography className={classes.subTitle}>
                            {props.subTitle}
                        </Typography>
                    )}
                </Typography>

                {props.isLoading ? (
                    <LoadingIndicator className={classes.indicator} />
                ) : (
                    <>
                        <StatisticsComponentItem
                            subTitle={"Min"}
                            data={props.min}
                            unit={props.unit}
                        ></StatisticsComponentItem>
                        <StatisticsComponentItem
                            subTitle={"Max"}
                            unit={props.unit}
                            data={props.max}
                        ></StatisticsComponentItem>
                        <StatisticsComponentItem
                            subTitle={"Mean"}
                            unit={props.unit}
                            data={props.mean}
                        ></StatisticsComponentItem>
                        <StatisticsComponentItem
                            subTitle={"Stand. Dev."}
                            unit={props.unit}
                            data={props.stdDev}
                        ></StatisticsComponentItem>
                    </>
                )}
            </div>
        </Paper>
    );
});
